import classNames from "classnames";
import { Entry } from "contentful";
import React from "react";

import EscapeNewLine from "~/components/common/escape-new-line";
import HighlightedText from "~/components/common/highlighted-text";
import SingleAsset from "~/components/common/single-asset";
import EditorialLink from "~/components/editorials/editorial-link/editorial-link";
import Editorials from "~/types/editorials";
import contentfulUtils from "~/utils/contentful-utils";
import { assertEditorialType } from "~/utils/editorial-utils";

import styles from "./editorial-card-plp.module.scss";

type Props = {
  entry: Entry<unknown>;
  numberColumnsDesktop: number;
};

export default function EditorialCardPLP({ entry, numberColumnsDesktop }: Props) {
  assertEditorialType<Editorials.Card>(entry, "card");
  const inspectorMode = contentfulUtils.useInspectorMode(entry);
  const { media, singleAsset, title, description, link } = entry.fields;

  return (
    <div
      className={classNames(
        "beacon-editorial-card-plp",
        styles.container,
        numberColumnsDesktop === 1 ? styles.oneColumn : undefined
      )}
    >
      {media || singleAsset ? (
        <div className={styles.media}>
          <SingleAsset entry={singleAsset} entryFallback={media} />
        </div>
      ) : null}
      <div className={styles.containerText}>
        <div className={styles.title} {...inspectorMode?.getProps("title")}>
          <HighlightedText text={title} />
        </div>
        <div className={styles.description} {...inspectorMode?.getProps("description")}>
          <EscapeNewLine text={description} />
        </div>
        {link ? <EditorialLink entry={link} lookAsButton="secondary" /> : null}
      </div>
    </div>
  );
}
